import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component, EventEmitter } from '@angular/core';
import * as moment from 'moment-timezone';

const MSK_TIMEZONE = 'Europe/Moscow';

@Component({
  selector: 'crm-datepicker',
  templateUrl: './datepicker.component.html'
})
export class DatepickerComponent {
  public _value: Date;

  public _minDate: Date;
  public _maxDate: Date;

  @Input()
  public set value(date: Date | string) {
    if (date) {
      this._value = this.isDateOnlyMode() ? this.toCalendarDateFromMskInstant(date) : new Date(date);
    }
  }

  @Input()
  public set minDate(date: Date | string) {
    if (date) {
      this._minDate = new Date(date);
    }
  }

  @Input()
  public set maxDate(date: Date | string) {
    if (date) {
      this._maxDate = new Date(date);
    }
  }

  @Output() public valueChange = new EventEmitter<Date>();

  @Input() public class: string;
  @Input() public modelOptions: any;
  @Input() public showButtonBar = false;
  @Input() public dateFormat = 'dd.mm.yy';
  @Input() public defaultDate: Date = new Date();
  @Input() public monthNavigator: boolean;
  @Input() public yearNavigator: boolean;
  @Input() public yearRange: string;
  @Input() public readonlyInput = true;
  @Input() public placeholder: string;
  @Input() public styleClass: string;
  @Input() public inputStyleClass: string;
  @Input() public timeOnly = false;
  @Input() public showTime = false;

  public onModelChange(date: Date): void {
    if (!date) {
      this.valueChange.emit(date);
      return;
    }
    if (this.isDateOnlyMode()) {
      this.valueChange.emit(this.toMskMidnightFromCalendarDate(date));
      return;
    }
    this.valueChange.emit(date);
  }

  private isDateOnlyMode(): boolean {
    return !this.showTime && !this.timeOnly;
  }

  /** Calendar day in MSK (same as date pipe GMT+3), as local Date for p-calendar. */
  private toCalendarDateFromMskInstant(date: Date | string): Date {
    const msk = moment(date).tz(MSK_TIMEZONE);
    return new Date(msk.year(), msk.month(), msk.date());
  }

  /** Selected y/m/d in the picker → midnight Europe/Moscow as Date for API. */
  private toMskMidnightFromCalendarDate(date: Date): Date {
    return moment
      .tz(
        { year: date.getFullYear(), month: date.getMonth(), date: date.getDate() },
        MSK_TIMEZONE
      )
      .toDate();
  }

}
